/* Shared look of floating panels: menus, popovers and select lists. */
.panel {
  z-index: var(--z-popover);
  min-width: var(--size-menu);
  max-width: calc(100vw - var(--space-8));
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow-2);
  color: var(--color-fg);
}

.list {
  padding: var(--space-1);
}

.item {
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-height: var(--size-control-sm);
  padding: 0 var(--space-2);
  border-radius: var(--radius-sm);
  font-size: var(--text-base);
  outline: none;
  cursor: pointer;
  user-select: none;
}

.item[data-highlighted] {
  background: var(--color-accent-subtle);
}

.item[data-disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.item svg {
  width: var(--size-icon);
  height: var(--size-icon);
  flex-shrink: 0;
  color: var(--color-fg-muted);
}

.indented {
  padding-left: var(--space-8);
}

.indicator {
  position: absolute;
  left: var(--space-2);
  display: inline-flex;
}

.indicator svg {
  color: var(--color-accent-text);
}

.danger {
  color: var(--color-fail);
}

.danger svg {
  color: var(--color-fail);
}

.shortcut {
  margin-left: auto;
  padding-left: var(--space-4);
  color: var(--color-fg-muted);
  font-size: var(--text-xs);
}

.chevron {
  display: block;
  width: 1em;
  height: 1em;
}

.separator {
  height: 1px;
  margin: var(--space-1) calc(var(--space-1) * -1);
  background: var(--color-border);
}

.label {
  padding: var(--space-1-5) var(--space-2) var(--space-1);
  color: var(--color-fg-muted);
  font-size: var(--text-xs);
  font-weight: var(--weight-medium);
  letter-spacing: 0.02em;
  text-transform: uppercase;
}
